import React, { useEffect } from "react";
import styled from "styled-components";
import qs from "qs";
import { Button, Alert } from "components/bootstrap";
import getDisplayName from "authentication/helpers/getDisplayName";
import { AUTH_SERVICE_TYPE, SSO_PATH_PREFIX } from "authentication/components/saml/constants";
import { prefixUrl } from "routing/Routes";
import { LOGIN_INITIALIZED_STATE } from "logic/authentication/constants";
import { currentPathnameWithoutPrefix } from "util/URLUtils";
const StyledA = styled.a`
  &:hover {
    text-decoration: none;
  }
`;
const StyledButton = styled(Button)`
  margin-top: 1em;
  display: block;
  cursor: pointer;
  width: 100%;
`;
const parseError = (encodedError) => {
  if (!encodedError) {
    return void 0;
  }
  try {
    return JSON.parse(decodeURIComponent(atob(encodedError)));
  } catch (e) {
    return { message: e.message };
  }
};
const SAMLLoginForm = ({ setLoginFormState }) => {
  const { _saml_login_error_: loginError, ...otherParams } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true
  });
  const { message, status_code: statusCode } = parseError(loginError) || {};
  const statusMessage = statusCode ? ` (Status: ${statusCode})` : "";
  const displayName = getDisplayName(AUTH_SERVICE_TYPE);
  const newSearch = qs.stringify(otherParams);
  const currentRelativeUrl = `${currentPathnameWithoutPrefix()}${newSearch && `?${newSearch}`}`;
  const queryParams = qs.stringify({ relayState: encodeURIComponent(currentRelativeUrl) });
  const loginUrl = prefixUrl(`${SSO_PATH_PREFIX}/saml/login?${queryParams}`);
  useEffect(() => setLoginFormState(LOGIN_INITIALIZED_STATE), [setLoginFormState]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, message && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: `SAML Login Error${statusMessage}` }, message), /* @__PURE__ */ React.createElement(StyledA, { href: loginUrl }, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "info" }, `Login with ${displayName}`)));
};
export default SAMLLoginForm;
